var merge = function (target, source) {
    for (var key in source) {
        if (source[key] instanceof Object && key in target) {
            // @ts-expect-error
            Object.assign(source[key], merge(target[key], source[key]));
        }
    }
    return Object.assign(target || {}, source);
};
export var mergeObjects = function () {
    var objList = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objList[_i] = arguments[_i];
    }
    return objList.reduce(merge, {});
};
export var noop = function () { return undefined; };
